import { PlusIcon } from "lucide-react";

import { Button } from "../ui/button";

import DocsEmpty from "@/assets/images/docsEmpty.png";
import { IbtnVariant } from "@/interfaces/interfaces";
import { cn, formatToCapitalizedWords } from "@/lib/utils";

type EmptyDataProps = {
  title?: string;
  subtitle?: string;
  btnAction?: () => void;
  btnLabel?: string;
  btnVariant?: IbtnVariant;
  icon?: string;
  hideButton?: boolean;
  small?: boolean;
};

const EmptyData: React.FC<EmptyDataProps> = ({
  title,
  subtitle,
  btnAction,
  btnLabel,
  btnVariant,
  icon,
  hideButton,
  small,
}) => {
  const handleBtn = (): void => {
    if (btnAction) {
      btnAction();
    }
  };

  return (
    <div
      className={cn(
        "flex flex-col place-items-center  gap-4",
        small ? "md:my-4" : "md:my-12 lg:my-32",
      )}
    >
      <img src={DocsEmpty} className='mx-auto max-h-32' alt='empty ui' />
      <h2 className='text-lg font-medium 3xl:text-2xl '>
        {formatToCapitalizedWords(`No ${title ?? ""} Found`)}
      </h2>
      <p className='text-md'>{subtitle}</p>
      {btnAction && !hideButton && (
        <Button
          variant={`${btnVariant ? btnVariant : "default"}`}
          className='flex items-center justify-between'
          type='button'
          onClick={handleBtn}
        >
          {icon ? "header btn icon" : <PlusIcon size={20} className='mr-2' />}

          {btnLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyData;
